export default __webpack_public_path__ + "static/media/inferior-muelas@3x.e6c63057.png";